<template>
    <div class="taskAdd">
        <Head-view :showStyle="4"></Head-view>
        <div class="main">
            <div class="breadcrumb" @click="backClose">
                任务管理 &nbsp;/&nbsp;
                <span style="color: rgba(132, 133, 135, 1)">{{
                    editTitle
                }}</span>
            </div>
            <div class="breadcrumbChilder">{{ editTitle }}</div>
            <div class="showTba">
                <div class="addBox">
                    <div class="instMsg">任务信息</div>
                    <div class="commRowstyle marginTop_30 instMsg">
                        <div class="inpTitle"><span>*</span>任务名称</div>
                        <div class="inpFrom">
                            <el-input
                                v-model="instMsg.name"
                                placeholder="请输入"
                                @blur="trimBoth('name', instMsg.name)"
                            ></el-input>
                        </div>
                        <div class="inpTitle marginLeft_40">
                            <span>*</span>巡检路线
                        </div>
                        <div class="inpFrom">
                            <el-select
                                v-model="routeVal"
                                placeholder="请选择"
                                @change="getRouteDetail()"
                            >
                                <el-option
                                    v-for="item in depArr"
                                    :key="item.routeId"
                                    :label="item.name"
                                    :value="item.routeId"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="commRowstyle marginTop_30 instMsg">
                        <div class="inpTitle"><span>*</span>开始时间</div>
                        <div class="inpFrom">
                            <el-date-picker
                                v-model="instMsg.startTime"
                                type="date"
                                placeholder="选择日期"
                                @change="isStartExpireDate(instMsg.startTime)"
                            >
                            </el-date-picker>
                        </div>
                        <div class="inpTitle marginLeft_40">结束时间</div>
                        <div class="inpFrom">
                            <el-date-picker
                                v-model="instMsg.endTime"
                                type="date"
                                placeholder="选择日期"
                                @change="isEndExpireDate(instMsg.endTime)"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="commRowstyle marginTop_30 instMsg">
                        <div class="inpTitle"><span>*</span>巡检员</div>
                        <div class="inpFrom">
                            <el-select
                                v-model="staffVal"
                                clearable
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in rolePersonnelArr"
                                    :key="item.staffId"
                                    :label="item.name"
                                    :value="item.staffId"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="commRowstyle marginTop_30 instMsg">
                        <div class="inpTitle"><span>*</span>巡检时间</div>
                        <div class="inpFrom">
                            <el-time-picker
                                is-range
                                v-model="instMsg.inspectionTime"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                placeholder="选择时间范围"
                                value-format="HH:mm:ss"
                            >
                            </el-time-picker>
                        </div>
                    </div>
                    <div class="commRowstyle marginTop_30 instMsg">
                        执行周期
                    </div>
                    <div class="commRowstyle marginTop_30 instMsg checkedDate">
                        <div class="checkedOne">
                            <el-radio v-model="radio" label="1" @change="onceChange"
                                >执行一次</el-radio
                            >
                        </div>
                        <div class="checkedMon">
                            <el-radio v-model="radio" label="2" @change="onceChange">
                                每月
                                <el-select
                                    v-model="monVal"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="item in monArr"
                                        :key="item.val"
                                        :label="item.val"
                                        :value="item.val"
                                    >
                                    </el-option>
                                </el-select>
                                日
                            </el-radio>
                        </div>
                        <div class="checkedDay">
                            <el-radio v-model="radio" label="3" @change="onceChange">
                                每周
                                <el-select
                                    v-model="dayVal"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="item in dayArr"
                                        :key="item.val"
                                        :label="item.val"
                                        :value="item.val"
                                    >
                                    </el-option>
                                </el-select>
                            </el-radio>
                        </div>
                        <div class="">
                            <el-radio v-model="radio" label="4" @change="onceChange">
                                <el-select
                                    v-model="dateVal"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="item in dateArr"
                                        :key="item.val"
                                        :label="item.val"
                                        :value="item.val"
                                    >
                                    </el-option>
                                </el-select>
                                天一次
                            </el-radio>
                        </div>
                    </div>

                    <div class="marginTop_30 instMsg checkedDate">
                        <div class="remarks">备注</div>

                        <div class="textarea">
                            <el-input
                                type="textarea"
                                resize="none"
                                :autosize="{ minRows: 6, maxRows: 6 }"
                                v-model="instMsg.remarks"
                                placeholder=""
                            ></el-input>
                        </div>
                    </div>
                </div>
                <div class="routerMsgBox">
                    <div class="routerName">{{ routeName }}</div>
                    <div class="routerImg">
                        <img v-if="routeImg" :src="routeImg" alt="" />
                        <img v-if="routeVal && !routeImg" src="../../../assets/routerDefaultImg.png" alt="">
                        <div class="nullImg" v-if="!routeVal && !routeImg">暂无路线图片</div>
                    </div>
                    <div class="routerList">点位列表</div>
                    <div class="routerMenu">
                        <div
                            class="menuSelect"
                            v-for="(item, key) in routePlaceArr"
                            :key="key"
                        >
                            <div class="menuNum">{{ item.orderNumber }}</div>
                            <div class="check">
                                <div class="imgSopt">
                                    <img v-if="item.picture" :src="item.picture" alt="" />
                                    <img v-if="!item.picture" src="../../../assets/placeDefaultImg.png" alt="" />
                                </div>
                                <div class="fontSopt">{{ item.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot">
            <div class="btn">
                <div class="commBtn closeBtn" @click="backClose()">取消</div>
                <div class="commBtn successBtn" @click="preservationData()">
                    保存
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
import { getTime } from "../../../untils/tools";
export default {
    name: "taskAdd",
    data() {
        return {
            insId: "",
            instMsg: {
                name: "",
                remarks: "", //备注
                startTime: "",
                endTime: "",
                inspectionTime: [new Date(), new Date()],
            },
            staffVal: "",
            rolePersonnelArr: [],

            radio: "",

            monVal: "",
            monArr: [],

            routeName: "",
            routeVal: "",
            depArr: [],

            dayVal: "",
            dayArr: [],

            dateVal: "",
            dateArr: [],

            expireDate: "",
            routeImg: "",
            routePlaceArr: [],
            editTitle: "新建任务",
            editFlag: false, //是否为编辑
            userNumber: "",

            onceFlag: false,
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"))
        this.getRouteInfo();
        this.rolePersonnelInfo(); //部门人员

        this.dateInfo();
        if (this.$route.query.id) {
            this.editTitle = "编辑任务";
            this.editFlag = true;
            this.userNumber = this.$route.query.id;
            this.taskEditInfo(this.$route.query.id);
        }
    },

    methods: {
        getRouteInfo() {
            let data = {
                insId: this.insId,
                token: this.getCookie(),
            };
            this.request
                .post(this.baseUrl + "route/getAllRouteList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.depArr = res.data;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "获取部门失败",
                    });
                });
        },

        rolePersonnelInfo() {
            let data = {
                insId: this.insId,
                token: this.getCookie(),
            };
            this.request
                .post(this.baseUrl + "institution/getAllStaffList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.rolePersonnelArr = res.data;
                        

                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "获取部门失败",
                    });
                });
        },

        dateInfo() {
            for (let x = 1; x <= 31; x++) {
                this.monArr.push({
                    val: x,
                });
                if (this.dayArr.length <= 6) {
                    this.dayArr.push({
                        val: x,
                    });
                }
            }
            new Array(365).fill(undefined).map((item, key) => {
                this.dateArr.push({
                    val: key + 1,
                });
            });
            this.dateVal = this.dateArr[0]["val"];
            this.dayVal = this.dayArr[0]["val"];
            this.monVal = this.monArr[0]["val"];
            this.dayArr[6]["val"] = "日";
        },

        getRouteDetail() {
            //获取路线详情
            let data = {
                token: this.getCookie(),
                routeId: this.routeVal,
            };
            this.request
                .post(this.baseUrl + "route/getRouteDetail", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.routeName = res.data.name
                        this.routeImg = res.data.picture;
                        this.routePlaceArr = res.data.placeList;
                    }
                });
        },

        taskEditInfo(taskId) {
            let data = {
                token: this.getCookie(),
                taskId: taskId,
            };
            this.request
                .post(this.baseUrl + "task/getTaskDetail", data)
                .then((res) => {
                    if (res.code == 0 && res.data.name) {
                        this.instMsg.name = res.data.name;
                        this.instMsg.remarks = res.data.remarks;
                        this.routeVal = res.data.routeId;
                        this.staffVal = res.data.staffId;
                        let startTime =
                            "2022-01-01 " + res.data.inspectStartTime;
                        let endTime = "2022-01-01 " + res.data.inspectStopTime;

                        this.instMsg.startTime = new Date(
                            res.data.taskStartDate
                        );
                        this.instMsg.endTime = res.data.taskStopDate
                            ? new Date(res.data.taskStopDate)
                            : "";
                        this.instMsg.inspectionTime = [
                            new Date(startTime),
                            new Date(endTime),
                        ];

                        switch (res.data.frequencyType) {
                            case 1: //执行一次
                                this.radio = "1";
                                break;
                            case 2: //每天
                                this.radio = "4";
                                this.dateVal = res.data.frequency;
                                break;
                            case 3: //每周
                                this.radio = "3";
                                this.dayVal = res.data.frequency;
                                break;
                            case 4: //每月
                                this.radio = "2";
                                this.monVal = res.data.frequency;
                                break;
                        }
                        this.getRouteDetail();
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.$message({
                        type: "error",
                        message: "获取详情失败",
                    });
                });
        },

        handleChange() {},

        trimBoth(type, val) {
            let trimVal = val.trim();

            switch (type) {
                case "name":
                    this.instMsg.name = trimVal;
                    break;
                default:
                    break;
            }
        },

        preservationData() {
            //保存信息
            if (
                !this.instMsg.name ||
                !this.instMsg.startTime ||
                !this.routeVal ||
                !this.staffVal
            ) {
                return this.$message({
                    type: "warning",
                    message: "带有*标志的均不能为空",
                });
            }

            if (!this.radio) {
                return this.$message({
                    type: "warning",
                    message: "请选择巡检周期",
                });
            }
            const loading = this.$loading({
                lock: true,
                text: "保存信息中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });

            let inspectStopTime = getTime(3, this.instMsg.inspectionTime[1]);
            let inspectStartTime = getTime(3, this.instMsg.inspectionTime[0]);
            let taskStartDate = getTime(2, this.instMsg.startTime);
            let taskStopDate = this.instMsg.endTime ? getTime(2, this.instMsg.endTime) : ""

            let frequencyType = 1;
            let frequency = 1;

            switch (this.radio) {
                case "2": //每月
                    frequencyType = 4;
                    frequency = this.monVal;
                    break;
                case "3": //每周
                    frequencyType = 3;
                    frequency = this.dayVal == '日' ? 7 : this.dayVal;
                    break;
                case "4": //每天
                    frequencyType = 2;
                    frequency = this.dateVal;
                    break;
            }
            let data = {
                token: this.getCookie(),
                insId: this.insId,
                name: this.instMsg.name,
                routeId: this.routeVal,
                taskStartDate: taskStartDate,
                taskStopDate: taskStopDate ? taskStopDate : "",
                staffId: this.staffVal,
                frequencyType: frequencyType,
                frequency: frequency,
                remarks: this.instMsg.remarks,
                inspectStopTime: inspectStopTime,
                inspectStartTime: inspectStartTime,
            };
            

            if (this.editFlag) {
                data["taskId"] = this.userNumber;
                this.request
                    .post(this.baseUrl + "task/updateTask", data)
                    .then((res) => {
                        if (res.code == 0) {
                            if (res.data.result) {
                                loading.close();
                                this.$message({
                                    type: "success",
                                    message: "保存成功",
                                });
                                setTimeout(() => {
                                    this.$message.closeAll();
                                    this.$router.push("/task");
                                }, 500);
                            } else {
                                loading.close();
                                this.$message({
                                    type: "warning",
                                    message: '当前任务正在巡检中，无法修改',
                                });
                            }
                        } else {
                            loading.close();
                            this.$message({
                                type: "error",
                                message: res.msg,
                            });
                        }
                    })
                    .catch((err) => {
                        loading.close();
                        this.$message({
                            type: "error",
                            message: err,
                        });
                    });
                return;
            }

            this.request
                .post(this.baseUrl + "task/addTask", data)
                .then((res) => {
                    if (res.code == 0) {
                        if (res.data.result) {
                            loading.close();
                            this.$message({
                                type: "success",
                                message: "保存成功",
                            });
                            setTimeout(() => {
                                this.$message.closeAll();
                                this.$router.push("/task");
                            }, 500);
                        } else {
                            loading.close();
                            this.$message({
                                type: "warning",
                                message: res.msg,
                            });
                        }
                    } else {
                        loading.close();
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    loading.close();
                    this.$message({
                        type: "error",
                        message: err,
                    });
                });
        },

        saveInformation(url = "", loading) {
            let data = {
                token: getCookie(),
                insId: this.insId,
                name: this.instMsg.name,
                portrait: url,
                role: this.staffVal,
                deptId: this.depVal,
            };
            console.log(data);
            this.request
                .post(this.baseUrl + "institution/addInsStaff", data)
                .then((res) => {
                    if (res.code == 0) {
                        if (res.data.result) {
                            loading.close();
                            this.$message({
                                type: "success",
                                message: "保存成功",
                            });
                            setTimeout(() => {
                                this.$message.closeAll();
                                this.$router.push("/personnel");
                            }, 1000);
                        } else {
                            loading.close();
                            this.$message({
                                type: "warning",
                                message: res.msg,
                            });
                        }
                    } else {
                        loading.close();
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    loading.close();
                    this.$message({
                        type: "error",
                        message: err,
                    });
                });
        },

        isEndExpireDate(endTime) {
            if (endTime == null) return
            if (this.onceFlag) {
                return this.instMsg.startTime = endTime
            }

            if (!this.instMsg.startTime) {
                this.instMsg.endTime = ""
                return this.$message({
                    type: "warning",
                    message: "请先选择开始时间",
                });
            }
            let val = new Date(this.instMsg.startTime).getTime();
            if (val > new Date(endTime).getTime()) {
                this.instMsg.endTime = "";
                return this.$message({
                    type: "warning",
                    message: "结束时间需大于开始时间",
                });
            }
        },

        isStartExpireDate(startTime) {
            if (this.onceFlag) {
                return this.instMsg.endTime = startTime
            }
            if (!this.instMsg.endTime) return
            
            let val = new Date(this.instMsg.endTime).getTime();
            if (val < new Date(startTime).getTime()) {
                this.instMsg.startTime = "";
                return this.$message({
                    type: "warning",
                    message: "开始时间需小于结束时间",
                });
            }
        },

        onceChange(e) {
            if (e == 1) {
                this.instMsg.endTime = this.instMsg.startTime
                this.onceFlag = true
            } else {
                this.onceFlag = false
            }
        },

        backClose() {
            this.$router.replace("/task");
        },
    },
};
</script>

<style lang="less" scoped>
.taskAdd {
    position: relative;
    height: 100vh;
    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        overflow: hidden;
        .breadcrumb {
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
            cursor: pointer;
        }
        .breadcrumbChilder {
            margin-top: 24px;
            height: 20px;
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
        }

        .showTba {
            display: flex;
            flex-direction: row;
            margin-top: 24px;
            margin-right: 7px;
            height: 692px;
            background: #fff;
        }
    }

    .addBox {
        width: 951px;
        padding: 24px 0 0 24px;
        .instMsg {
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            font-weight: 500;
        }

        .userNum {
            line-height: 40px;
            color: rgba(84, 85, 86, 1);
            font-size: 14px;
        }

        .commRowstyle {
            display: flex;
            flex-direction: row;
            .inpTitle {
                width: 107px;
                color: rgba(84, 85, 86, 1);
                font-size: 14px;
                line-height: 40px;
                font-weight: 500;
                span {
                    color: red;
                }
            }
            .inpFrom {
                width: 265px;

                input {
                    width: 100%;
                }
            }

            .codeFont {
                line-height: 40px;
                font-size: 14px;
            }
        }

        .marginTop_30 {
            margin-top: 30px;
        }

        .marginLeft_40 {
            margin-left: 40px;
            text-align: left;
        }

        .checkedDate {
            margin-top: 13px;
            line-height: 40px;

            .checkedOne {
                width: 125px;
            }

            .checkedMon {
                width: 231px;
            }

            /deep/ .el-input__inner {
                width: 86px;
            }

            .checkedDay {
                width: 262px;
                /deep/ .el-input__inner {
                    width: 153px;
                }
            }

            .textarea {
                width: 493px;
            }
        }

        .tip {
            padding-top: 21px;
            padding-left: 15px;
            color: rgba(144, 147, 153, 1);
            font-size: 13px;
            height: 19px;
            font-weight: 400;
            text-align: left;
        }

        .userNumber {
            padding-bottom: 10px;
            color: rgba(84, 85, 86, 1);
            font-size: 14px;
            font-weight: 500;
        }

        .tipBox {
            padding-left: 15px;

            > .tip {
                padding: 0;
                padding-top: 1px;
            }
        }
    }

    .routerMsgBox {
        margin: 24px 0 20px 0;
        padding: 20px;
        width: 433px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(216, 220, 230, 1);

        .routerName {
            color: rgba(48, 49, 51, 1);
            text-align: left;
            font-size: 16px;
        }

        .routerImg {
            margin-top: 12px;
            width: 210px;
            height: 210px;
            overflow: hidden;
            .nullImg {
                padding-top: 20px;
                font-size: 14px;
                text-align: center;
                color: #aaa;
            }
            img {
                width: 100%;
            }
        }

        .routerList {
            margin-top: 20px;
        }

        .routerMenu {
            margin-top: 12px;
            width: 393px;
            height: 306px;
            border: 1px solid rgba(246, 245, 245, 1);
            overflow-y: auto;

            .menuSelect {
                display: flex;
                flex-direction: row;
                margin: 0 20px;
                height: auto;
                border-bottom: 1px solid rgba(229, 229, 229, 0.5);
                .menuNum {
                    margin-top: 37px;
                    width: 24px;
                    height: 24px;
                    line-height: 24px;
                    opacity: 0.7;
                    border-radius: 45px;
                    text-align: center;
                    font-size: 14px;
                    color: #fff;
                    background: rgba(25, 137, 250, 1);
                }

                .check {
                    padding: 10px 0;
                }

                /deep/ .el-radio__input {
                    display: block;
                    float: left;
                    margin-top: 32px;
                }

                .imgSopt {
                    // display: inline-block;
                    float: left;
                    margin-left: 16px;
                    width: 78px;
                    height: 78px;
                    overflow: hidden;
                    img {
                        width: 100%;
                    }
                }

                .fontSopt {
                    float: left;
                    margin-left: 16px;
                    line-height: 78px;
                }
            }
        }
    }

    .foot {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 71px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;

        .btn {
            float: right;
            display: flex;
            flex-direction: row;
            padding-top: 15.5px;
            padding-right: 56px;
            .commBtn {
                width: 95px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }

            .successBtn {
                color: rgba(255, 255, 255, 1);
                background: rgba(103, 194, 58, 1);
            }

            .closeBtn {
                margin-right: 24px;
                color: rgba(96, 98, 102, 1);
                font-size: 14px;
                font-weight: 500;
                border: 1px solid rgba(220, 223, 230, 1);
            }
        }
    }
}

/deep/ .el-input__inner {
    width: 256px;
}

.inpColorRed {
    /deep/ .el-input__inner {
        border: 1px solid red;
    }
}
</style>